module.exports = __webpack_public_path__ + "static/gopher.b0e8ad8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/tags/assets/gopher.png
// module id = 407
// module chunks = 35783957827783 240266527212553